import React from 'react';

interface ConnectionStatusIndicatorProps {
  status: 'connected' | 'disconnected' | 'reconnecting';
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const ConnectionStatusIndicator: React.FC<ConnectionStatusIndicatorProps> = ({
  status,
  size = 'md',
  showText = true,
  className = ''
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'connected':
        return {
          icon: '🟢',
          text: 'Connected',
          color: 'text-green-600',
          bgColor: 'bg-green-100',
          borderColor: 'border-green-200'
        };
      case 'disconnected':
        return {
          icon: '🔴',
          text: 'Disconnected',
          color: 'text-red-600',
          bgColor: 'bg-red-100',
          borderColor: 'border-red-200'
        };
      case 'reconnecting':
        return {
          icon: '🟡',
          text: 'Reconnecting',
          color: 'text-yellow-600',
          bgColor: 'bg-yellow-100',
          borderColor: 'border-yellow-200'
        };
      default:
        return {
          icon: '⚪',
          text: 'Unknown',
          color: 'text-gray-600',
          bgColor: 'bg-gray-100',
          borderColor: 'border-gray-200'
        };
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return {
          container: 'px-2 py-1 text-xs',
          icon: 'text-sm',
          text: 'text-xs'
        };
      case 'lg':
        return {
          container: 'px-4 py-2 text-base',
          icon: 'text-xl',
          text: 'text-base'
        };
      default: // md
        return {
          container: 'px-3 py-1 text-sm',
          icon: 'text-base',
          text: 'text-sm'
        };
    }
  };

  const statusConfig = getStatusConfig();
  const sizeClasses = getSizeClasses();

  return (
    <div
      className={`
        inline-flex items-center rounded-full font-medium
        ${statusConfig.bgColor} ${statusConfig.color} ${statusConfig.borderColor}
        ${sizeClasses.container}
        ${className}
      `}
    >
      <span className={`${sizeClasses.icon} ${showText ? 'mr-1' : ''}`}>
        {statusConfig.icon}
      </span>
      {showText && (
        <span className={sizeClasses.text}>
          {statusConfig.text}
        </span>
      )}
    </div>
  );
};

export default ConnectionStatusIndicator;
